import React, { useState } from "react";
import { Slide } from "react-awesome-reveal";
import { CgProfile } from "react-icons/cg";
import { MdAlternateEmail } from "react-icons/md";
import { FiMail } from "react-icons/fi";
import { useFormik } from "formik";
import axios from "axios";
import { toast } from "react-toastify";
import { signUpSchema } from "../../schemas";

const initialValues = {
  name: "",
  email: "",
  message: "",
  company: "",
};

const ContactForm = () => {
  const [loading, setLoading] = useState(false);

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema: signUpSchema,
      onSubmit: async (values, action) => {
        setLoading(true); // start loader
        try {
          const response = await axios.post(
            `https://portfolio-backend-n3kata.fly.dev/api/contact`,
            values,
          );

          action.resetForm();

          if (response.status === 200) {
            toast.success("Message send successfully", {
              position: "bottom-left",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "dark",
            });
          }
        } catch (error) {
          if (error.response && error.response.status === 429) {
            toast.error("Too many requests. Please try again later", {
              position: "bottom-left",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "dark",
            });
          } else {
            toast.error("Failed to send message", {
              position: "bottom-left",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "dark",
            });
          }
        } finally {
          setLoading(false); // stop loader no matter what
        }
      },
    });

  return (
    <Slide direction="right">
      <form onSubmit={handleSubmit}>
        <div className="name">
          <span>
            <CgProfile />
          </span>
          <input
            type="text"
            autoComplete="off"
            name="name"
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Fullname..."
          />
        </div>
        {errors.name && touched.name ? (
          <p style={{ color: "red", marginBottom: ".5rem" }}>{errors.name}</p>
        ) : null}
        <div className="email">
          <span>
            <MdAlternateEmail />
          </span>
          <input
            type="email"
            autoComplete="off"
            name="email"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Email..."
          />
        </div>
        {errors.email && touched.email ? (
          <p style={{ color: "red", marginBottom: ".5rem" }}>{errors.email}</p>
        ) : null}
        <div className="message">
          <span className="messageIcon">
            <FiMail />
          </span>
          <textarea
            cols="30"
            rows="10"
            autoComplete="off"
            name="message"
            value={values.message}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Message..."
          ></textarea>
        </div>
        {errors.message && touched.message ? (
          <p style={{ color: "red", marginBottom: ".5rem" }}>
            {errors.message}
          </p>
        ) : null}
        <input
          type="text"
          name="company"
          value={values.company}
          onChange={handleChange}
          onBlur={handleBlur}
          style={{ display: "none" }}
        />
        <button
          aria-label="Submit Form"
          type="submit"
          style={{
            cursor: loading ? "not-allowed" : "pointer",
            fontWeight: "bold",
          }}
          onClick={(e) => loading && e.preventDefault()}
        >
          {loading ? "Sending..." : "Send Message"}
        </button>
      </form>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <p style={{ marginTop: "10px" }}>
          <span role="img" aria-label="Lightning">
            ⚡
          </span>{" "}
          Usually replies within 24 hours
        </p>
        <p style={{ marginTop: "10px" }}>
          <span role="img" aria-label="Lock">
            🔒
          </span>{" "}
          Your information will never be shared
        </p>
      </div>
    </Slide>
  );
};

export default ContactForm;
